import { api, ENDPOINTS } from '../config';
import { CameraFilters, CameraResponse, CameraResponseData } from './types';

/**
 * Fetch devices with optional filters
 */
export async function getCamera(filters?: CameraFilters): Promise<CameraResponseData> {
  const response = await api.get<CameraResponse>(ENDPOINTS.CAMERA, {
    params: filters,
  });
  
  return response.data;
}